__turbopack_context__.v({
  "container": "Bio-module__zbbBmq__container",
  "fadeInItems": "Bio-module__zbbBmq__fadeInItems",
  "spacing--lg": "Bio-module__zbbBmq__spacing--lg",
  "spacing--md": "Bio-module__zbbBmq__spacing--md",
  "spacing--sm": "Bio-module__zbbBmq__spacing--sm",
  "spacing--xl": "Bio-module__zbbBmq__spacing--xl",
  "spacing--xs": "Bio-module__zbbBmq__spacing--xs",
  "spacing--xxl": "Bio-module__zbbBmq__spacing--xxl",
  "spacing--xxs": "Bio-module__zbbBmq__spacing--xxs",
  "spacing--xxxl": "Bio-module__zbbBmq__spacing--xxxl",
  "spacing--xxxs": "Bio-module__zbbBmq__spacing--xxxs",
  "wrapper": "Bio-module__zbbBmq__wrapper",
});
